import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Constant from '../../Constant.js'
import axios from 'axios'
import Swal from 'sweetalert2'
import CheckPermission from '../../common/Permissions/CheckPermission.js'
import Button from '../../common/CustomComponents/Button.js'
import ActivitiesController from '../../common/activitiesController/ActivitiesController.js'
class ViewBoatDetails extends Component {
  state = {
    categoryList: [],
    isLoading: false,
  }
  myStyle = {
    fontWeight: 'bold',
  }
  StyleForDetail = {
    marginBottom: '6px',
    letterSpacing: '0.5px',
    display: 'inline-block',
  }
  componentDidMount() {
    this.getCategoryMaster()
  }
  getCategoryMaster = async () => {
    var that = this
    var cruiseId = this.props.match?.params?.boatId
    that.setState({ isLoading: true })
    await axios
      .get(Constant.getAPI() + `/cruise/get-cruise/${cruiseId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data?.success) {
          that.setState({
            categoryList: res?.data?.data,
          })
          that.setState({ isLoading: false })
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    // var cruiseId = this.props.match.params.boatType;
    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>{this.props.match?.params?.boatType} Details</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item">
                        <span onClick={() => window.history.back()}>{this.props.match?.params?.boatType} Lists </span>
                      </li>
                      <li className="breadcrumb-item active">{this.props.match?.params?.boatType} Details</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div
                        className="row"
                        style={{ padding: '0 10px 15px 10px', borderBottom: '1px solid #ddd' }}
                      >
                        <Button
                          to={`/boatsmaster/cruise/${this.props.match?.params?.boatType}/add/${this.props?.match?.params.boatId}`}
                        >
                          Edit
                        </Button>
                        <Button
                          to={`/boatsmaster/${this.props.match?.params?.boatType}/${this.props?.match?.params.boatId}/diwaniya-lists`}
                        >
                          Diwaniya
                        </Button>
                        <Button
                          to={`/boatsmaster/${this.props?.match?.params?.boatType}/${this.props.match?.params?.boatId}/boat-timeslot-lists`}
                        >
                          TimeSlots
                        </Button>
                        <Button
                          to={`/boatsmaster/${this.props?.match?.params?.boatType}/${this.props.match?.params?.boatId}/boat-block-date-lists`}
                        >
                          Block Dates
                        </Button>
                        <Button
                          to={`/boatsmaster/${this.props.match?.params?.boatType}/${this.props.match?.params?.boatId}/destination-lists`}
                        >
                          Destinations
                        </Button>
                        <Button
                          to={`/boatsmaster/${this.props.match?.params?.boatType}/${this.props.match?.params?.boatId}/banner-lists`}
                        >
                          Banners
                        </Button>
                        <Button to={`/gallary-list/cruise/${this.props.match?.params?.boatId}`}>Gallary</Button>
                        <Button
                          to={`/boatsmaster/${this.props.match?.params?.boatType}/${this.props.match?.params?.boatId}/additionhours-lists`}
                        >
                          Additional Hours
                        </Button>
                        <Button
                          to={`/boatsmaster/${this.props.match?.params?.boatType}/${this.props.match?.params?.boatId}/pickup-lists`}
                        >
                          Pick Up
                        </Button>
                        <Button
                          to={`/boatsmaster/${this.props.match?.params?.boatType}/${this.props.match?.params?.boatId}/boatRating-lists`}
                        >
                          Ratings
                        </Button>
                        <CheckPermission permission={'contract-files'}>
                          <Button to={`/contract-files/cruise/${this.props.match?.params?.boatId}`}>
                            Contract files
                          </Button>
                        </CheckPermission>
                        <ActivitiesController
                          style={{
                            backgroundColor: '#3f51b5',
                            color: 'white',
                            marginRight: 5,
                            marginBottom: 5,
                            textTransform: 'none',
                            minWidth: '150px',
                          }}
                          refId={this.props.match?.params?.boatId}
                          status="true"
                        >
                          Status History
                        </ActivitiesController>
                      </div>
                      <div
                        className="row"
                        style={{ padding: 10, borderBottom: '1px solid #ddd' }}
                      >
                        <div
                          className="col-md-6 col-sm-12"
                          style={{ borderRight: '1px solid #ddd' }}
                        >
                          <div className="row">
                            <div
                              className="col-3"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Yacht Details</div>
                            </div>
                            <div
                              className="col-4"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>ID</div>
                            </div>
                            <div className="col-5">
                              <div style={{ color: 'red', fontWeight: 'bold' }}>
                                {this.state.categoryList?.id || '--'}
                              </div>
                            </div>
                          </div>
                          <div
                            className="row"
                            style={{ marginBottom: 10 }}
                          >
                            <div
                              className="col-3"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div></div>
                            </div>
                            <div
                              className="col-4"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Name: English</div>
                              <div>Name: Arabic</div>

                              <div>Price</div>
                              <div>Speed</div>
                              <div>Size(ft)</div>
                              <div>Pax. Capacity</div>
                              <div style={{ height: 50 }}>Image Url</div>
                              <div>Fishing type : English</div>
                              <div>Fishing type : Arabic</div>
                              <div>Fishing tech : English</div>
                              <div>Fishing tech : Arabic</div>
                              <div>Amenities: English</div>
                              <div>Amenities : Arabic</div>
                            </div>
                            <div className="col-5">
                              <div>{this.state.categoryList?.cruise_name_en || '--'}</div>
                              <div>{this.state.categoryList?.cruise_name_ar || '--'}</div>
                              <div>{this.state.categoryList?.cruise_price || '--'}</div>
                              <div>{this.state.categoryList?.cruise_speed || '--'}</div>
                              <div>{this.state.categoryList?.cruise_width || '--'}</div>
                              <div>{this.state.categoryList?.cruise_pax_capacity || '--'}</div>
                              <div style={{ height: 50 }}>
                                <img
                                  src={
                                    this.state.categoryList?.cruise_large_img &&
                                      typeof this.state.categoryList?.cruise_large_img == 'string'
                                      ? Constant.getImage() + this.state.categoryList?.cruise_large_img
                                      : './assets/images/no_image.png'
                                  }
                                  className="img-fluid"
                                  alt="img"
                                  onError={(event) => {
                                    event.currentTarget.src = './assets/images/no_image.png'
                                  }}
                                  style={{ height: 40, border: '1px solid #aaa', borderRadius: 5 }}
                                />
                              </div>
                              <div>{this.state.categoryList?.cruise_fishing_type_en || '--'}</div>
                              <div>{this.state.categoryList?.cruise_fishing_type_ar || '--'}</div>
                              <div>{this.state.categoryList?.cruise_fishing_tech_en || '--'}</div>
                              <div>{this.state.categoryList?.cruise_fishing_tech_ar || '--'}</div>
                              <div>{this.state.categoryList?.cruise_amenities_en || '--'}</div>
                              <div>{this.state.categoryList?.cruise_amenities_ar || '--'}</div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-sm-12">
                          <div
                            className="row"
                            style={{ marginBottom: 10 }}
                          >
                            <div
                              className="col-3"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>PickUp Details</div>
                            </div>
                            <div
                              className="col-4"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Latitude</div>
                              <div>Longitude</div>
                              <div>Map</div>
                              <div>Destination</div>
                              <div>Other Details</div>
                              <div>Address</div>
                            </div>
                            <div className="col-5">
                              <div>{this.state.categoryList?.pickUp?.pickup_lat || '--'}</div>
                              <div>{this.state.categoryList?.pickUp?.pickup_long || '--'}</div>
                              <div>{this.state.categoryList?.pickUp?.pickup_map || '--'}</div>
                              <div>{this.state.categoryList?.pickUp?.pickup_desc || '--'}</div>
                              <div>{this.state.categoryList?.pickUp?.pickup_other_detail || '--'}</div>
                              <div>{this.state.categoryList?.pickUp?.pickup_address || '--'}</div>
                            </div>
                          </div>
                          <div
                            className="row"
                            style={{ marginBottom: 10 }}
                          >
                            <div
                              className="col-3"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Captain Details</div>
                            </div>
                            <div
                              className="col-4"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Name</div>
                              <div>Email</div>
                              <div>Contact</div>
                            </div>
                            <div className="col-5">
                              <div>
                                {this.state.categoryList?.captain?.first_name}{' '}
                                {this.state.categoryList?.captain?.last_name}
                              </div>
                              <div>{this.state.categoryList?.captain?.email || '--'}</div>
                              <div>{this.state.categoryList?.captain?.phone || '--'}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="row"
                        style={{ padding: 10, borderBottom: '1px solid #ddd' }}
                      >
                        <div
                          className="col-md-6 col-sm-12"
                          style={{ borderRight: '1px solid #ddd' }}
                        >
                          <div className="row">
                            <div
                              className="col-3"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Description:En</div>
                            </div>
                            <div className="col-4">
                              <div
                                dangerouslySetInnerHTML={{ __html: this.state.categoryList?.cruise_desc_en || '--' }}
                              ></div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-sm-12">
                          <div className="row">
                            <div
                              className="col-3"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Description:Ar</div>
                            </div>
                            <div className="col-9">
                              <div
                                dangerouslySetInnerHTML={{ __html: this.state.categoryList?.cruise_desc_ar || '--' }}
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="row"
                        style={{ padding: 10, borderBottom: '1px solid #ddd' }}
                      >
                        <div
                          className="col-md-6 col-sm-12"
                          style={{ borderRight: '1px solid #ddd' }}
                        >
                          <div className="row">
                            <div
                              className="col-3"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Yacht Policy:En</div>
                            </div>
                            <div className="col-4">
                              <div
                                dangerouslySetInnerHTML={{ __html: this.state.categoryList?.policy_en || '--' }}
                              ></div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-sm-12">
                          <div className="row">
                            <div
                              className="col-3"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Yacht Policy:Ar</div>
                            </div>
                            <div className="col-9">
                              <div
                                dangerouslySetInnerHTML={{ __html: this.state.categoryList?.policy_ar || '--' }}
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="row"
                        style={{ padding: 10, borderBottom: '1px solid #ddd' }}
                      >
                        <div
                          className="col-md-6 col-sm-12"
                          style={{ borderRight: '1px solid #ddd' }}
                        >
                          <div className="row">
                            <div
                              className="col-3"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Refund Policy:En</div>
                            </div>
                            <div className="col-4">
                              <div
                                dangerouslySetInnerHTML={{ __html: this.state.categoryList?.refund_policy_en || '--' }}
                              ></div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-sm-12">
                          <div className="row">
                            <div
                              className="col-3"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Refund Policy:Ar</div>
                            </div>
                            <div className="col-9">
                              <div
                                dangerouslySetInnerHTML={{ __html: this.state.categoryList?.refund_policy_ar || '--' }}
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ViewBoatDetails
